import React, { FC } from "react";

import { Product } from "@/services/productService";

import Img, { ImagePlaceholderType } from "@/components/img";
import ProductOverlayTag from "../../product/productOverlayTag";
import Discount from "./discount";
import "./style.scss";

const ContentImage: FC<{
  img: string;
  url: string;
  alt?: string;
  overlayLabel?: string;
  overlayTagBgColor?: string;
  overlayTagLabelColor?: string;
  lazyLoad?: boolean;
  imagePlaceholderType?: ImagePlaceholderType;
  showDiscountSlab?: boolean;
  item?: Product;
}> = ({
  img,
  url,
  alt,
  overlayLabel,
  overlayTagBgColor,
  overlayTagLabelColor,
  lazyLoad,
  imagePlaceholderType,
  showDiscountSlab = true,
  item
}) => {
  return (
    <div className="content_image">
      {img && url && (
        <Img
          src={`${url}${img}`}
          alt={alt}
          style={imageStyle}
          imagePlaceholderType={imagePlaceholderType}
          {...(lazyLoad ? { loading: "lazy" as const } : {})}
        />
      )}
      {showDiscountSlab && item && <Discount product={item} />}

      <ProductOverlayTag
        overlayLabel={overlayLabel}
        overlayTagBgColor={overlayTagBgColor}
        overlayTagLabelColor={overlayTagLabelColor}
      />
    </div>
  );
};

const imageStyle = { width: "100% " };

export default ContentImage;
